import { Reducer } from 'redux'

import { Action as CreateCitationAction } from '../createCitation/types'
import { ActionTypes } from './constants'
import { Action, StylesState } from './types'

export const initialState = {
  list: [],
  page: 1,
}

export const stylesReducer: Reducer<StylesState, Action | CreateCitationAction> = (
  state = initialState,
  action: Action | CreateCitationAction
) => {
  switch (action.type) {
    case ActionTypes.LOAD_STYLES:
      return {
        ...state,
        page: 1,
      }

    case ActionTypes.STYLES_REQUESTED:
      return {
        ...state,
        page: action.payload.page,
      }

    case ActionTypes.STYLES_FETCH_SUCCEEDED:
      return {
        ...state,
        list: action.payload.styles,
      }

    default:
      return state
  }
}

export default stylesReducer
